<template>
    <div id="fans">
        <van-nav-bar
                :title="title"
                :fixed="true"
                left-arrow
                @click-left="$router.go(-1)"
        />
        <van-list
                v-model="loading"
                :finished="finished"
                @load="onLoad"
        >
            <div class="list" v-for="(item, key) in list" :key="item.documentId" @click="$router.push(`/user/${item.id}`)">
                <img class="avatar" v-lazy="item.avatar + '?imageView2/1/w/40/h/40'" />
                <h5 class="name">{{ item.name }}</h5>
                <van-button class="button-focus active" size="small" @click.stop="onFocus(item.id, key, type(item.id))">
                    {{ typeAlias(item.id) }}
                </van-button>
            </div>
            <list-foot v-if="isError">出错了</list-foot>
            <list-foot v-else-if="hasLoaded && list.length === 0">没有数据</list-foot>
            <list-foot v-else-if="finished">到底了</list-foot>
        </van-list>
    </div>
</template>

<script>
  import ListFoot from '@/components/ListFoot';
  import {NavBar, List, Lazyload, Cell, Button, Toast} from 'vant';

  const LazyloadOptions = {
    loading: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/80/h/82',
    // error: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/80/h/82',
    preload: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/80/h/82'
  };
  import Vue from 'vue';
  Vue.use(NavBar).use(List).use(Lazyload, LazyloadOptions).use(Cell).use(Button).use(Toast);
  export default {
    name: 'UserFans',
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        hasLoaded: false,
        isError: false,
        isFans: true,
        title: ''
      };
    },
    components: {ListFoot},
    methods: {
      type(userId) {
        if (!this.isFans) {
          return -1;
        } else if (this.$store.state.userInfo.followUserIds.includes(userId)) {
          return -1;
        } else {
          return 1;
        }
      },
      typeAlias(userId) {
        if (!this.isFans) {
          return '已关注';
        } else if (this.$store.state.userInfo.followUserIds.includes(userId)) {
          return '相互关注';
        } else {
          return '未关注';
        }
      },
      onFocus(userId, key, type = 1) {
        if (1 === type) {
          this.$http.post('/api/user_more/follow', {id: userId}).then(() => {
            Toast('关注成功');
            let followUserIds = [...this.$store.state.userInfo.followUserIds];
            followUserIds.push(userId);
            this.$store.commit('USER_INFO', {
              follow: this.$store.state.userInfo.follow + 1,
              followUserIds
            });
          });
        } else {
          this.$http.post('/api/user_more/unFollow', {id: userId}).then(() => {
            if (!this.isFans) {
              this.list.splice(key, 1);
            }
            Toast('已取消关注');
            let followUserIds = [...this.$store.state.userInfo.followUserIds];
            let index = followUserIds.indexOf(userId);
            followUserIds.splice(index, 1);
            this.$store.commit('USER_INFO', {
              follow: this.$store.state.userInfo.follow - 1,
              followUserIds
            });
          });
        }
      },
      onLoad() {
        this.loading = true;
        this.$http.post(`/api/user_more/${this.isFans ? 'fans' : 'follows'}`, {
          id: this.$store.state.userInfo.userId
        }).then(data => {
          this.list = data;
          this.finished = true;
          this.loading = false;
          this.hasLoaded = true;
        }).catch(() => {
          this.loading = false;
          this.isError = true;
          this.hasLoaded = true;
        });
      }
    },
    activated() {
      this.list = [];
      this.finished = false;
      this.loading = false;
      this.hasLoaded = false;
      // this.onLoad();
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        if (vm.$route.params.isFans === '1') {
          vm.isFans = true;
          vm.title = '我的粉丝';
        } else {
          vm.isFans = false;
          vm.title = '我的关注';
        }
      });
    }
  };
</script>

<style scoped lang="less">
    #fans {
        /deep/ .van-nav-bar .van-icon {
            color: black;
        }

        /deep/ .van-list {
            margin-top: 46px;

            .list {
                display: flex;
                padding: 5px;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #eee;
                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin-top: 5px;
                }
                h5 {
                    font-size: 14px;
                    margin-left: 10px;
                    flex: auto;
                }
                .button-focus {
                    width: 70px;
                    height: 22px;
                    line-height: 22px;
                    background-color: white;
                    color: #e9aea8;
                    border-color: #e9aea8;
                    margin-top: 15px;
                }
                .button-focus.active {
                    color: white;
                    background-color: #e9aea8;
                }
            }
        }

    }

</style>